import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-east-1_7UfLHq5Ls",
  ClientId: "1fl3nmmj2vb4a5t80pos86qgb1",
};

export default new CognitoUserPool(poolData);
